export default __webpack_public_path__ + "static/logo-654fdf60d5e5bb314bf848fd748b5405.svg";